import React from 'react';
import PropTypes from 'prop-types';

import { Icon, Spacer } from '@ontruck/orc';

const LifgateCell = ({ lifgateNeeded, ...props }) => {
  return (
    lifgateNeeded && (
      <Spacer {...props}>
        <Icon glyph="extras-liftgate" color="grey500" size="3.2rem" />
      </Spacer>
    )
  );
};

LifgateCell.propTypes = {
  lifgateNeeded: PropTypes.bool,
};

export default LifgateCell;
